import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  DocumentTag_FieldsFragment,
  DocumentTag_UpdateDocumentTagInput,
  DocumentTagCategory,
} from 'queries';
import * as yup from 'yup';

import Modal from 'common/modal';

import DocumentTagForm from './document-tag-form';

const useStyles = makeStyles(() => ({
  container: {
    textAlign: 'left',
  },
  button: {
    marginTop: '20px',
  },
}));

const schema = yup.object().shape({
  id: yup.string().required('Required'),
  name: yup.string().required('Required'),
  pillTextColor: yup.string().required('Required'),
  pillBackgroundColor: yup.string().required('Required'),
  category: yup.string<DocumentTagCategory>().nullable(),
});

type EditDocumentTagModalProps = {
  onClose: () => void;
  documentTag: DocumentTag_FieldsFragment;
  onSubmit: (data: DocumentTag_UpdateDocumentTagInput) => void;
  updateDocumentTagExecuting: boolean;
};

const EditDocumentTagModal = ({
  onClose,
  onSubmit,
  updateDocumentTagExecuting,
  documentTag,
}: EditDocumentTagModalProps) => {
  const classes = useStyles();
  const formProviderProps = useForm<DocumentTag_UpdateDocumentTagInput>({
    // @ts-expect-error - RHF V7 limitation #7895
    resolver: yupResolver(schema),
    values: {
      id: documentTag.id,
      name: documentTag.name,
      pillTextColor: documentTag.pillTextColor,
      pillBackgroundColor: documentTag.pillBackgroundColor,
      category: documentTag.category,
      linkedField: documentTag.linkedField,
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formProviderProps;

  return (
    <Modal
      setShowModal={() => {}}
      onExitClick={onClose}
      showModal={true}
      showActions={false}
      content={
        <FormProvider {...formProviderProps}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Typography variant="h6">Edit Document Tag</Typography>
            <DocumentTagForm />
            <div className={classes.container}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                className={classes.button}
                disabled={isSubmitting || updateDocumentTagExecuting}
              >
                Save
              </Button>
            </div>
          </form>
        </FormProvider>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
};

export default EditDocumentTagModal;
